import React, { useState, useEffect } from "react";
import { Card } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { getRevenueReports } from '../../api/revenueService';
export default function RevenueReports() {
    const [searchText, setSearchText] = useState('');
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state

    // Fetch data from the API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getRevenueReports();
                if (response.success) {
                    // Format the response to match the existing structure
                    const formattedData = response.data.map((report, index) => ({
                        id: index + 1,
                        SrNo: index + 1,
                        Period: report.period.charAt(0).toUpperCase() + report.period.slice(1),
                        TotalRevenue: `$${report.totalRevenue.toFixed(2)}`,
                        NewSubscriptions: report.newSubscriptions.toString(),
                        Cancellations: report.cancellations.toString(),
                    }));
                    setReportData(formattedData);
                }
            } catch (error) {
                console.error("Error fetching revenue reports", error);
            } finally {
                setLoading(false); // Stop loading after the data is fetched
            }
        };

        fetchData();
    }, []);

    const columns = [
        {
            name: 'Sr.No.',
            width: '100px',
            selector: row => row.SrNo,
            sortable: true,
            cell: (row) => row.SrNo,
        },
        {
            name: 'Period',
            width: '150px',
            selector: row => row.Period,
            sortable: true,
            cell: (row) => row.Period,
        },
        {
            name: 'Total Revenue',
            width: '160px',
            selector: row => row.TotalRevenue,
            sortable: true,
            cell: (row) => row.TotalRevenue,
        },
        {
            name: 'Number of New Subscriptions',
            width: '260px',
            selector: row => row.NewSubscriptions,
            sortable: true,
            cell: (row) => row.NewSubscriptions,
        },
        {
            name: 'Number of Cancellations',
            width: '230px',
            selector: row => row.Cancellations,
            sortable: true,
            cell: (row) => row.Cancellations,
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                   <Link
                            className="btnview"
                            to={`/admin/report-detail?period=${row.Period.toLowerCase()}`}
                            >
                            <Icon icon="tabler:eye" />
                            </Link>
                    <Link className="btnedit">
                        <Icon icon="ph:export-bold" />
                    </Link>
                </>
            ),
        },
    ];

    // Filter data based on search text
    const filteredData = reportData.filter(
        item =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(searchText.toLowerCase()) !== -1
    );

    return (
        <React.Fragment>
            <Card>
                <Card.Header className="py-4">
                    <h5>Revenue Reports</h5>
                </Card.Header>
                <Card.Body>
                    <div className="text-end mb-3">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="searchfield"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                    </div>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        responsive
                        className="custom-table"
                        progressPending={loading} // Shows loading indicator while fetching data
                    />
                </Card.Body>
            </Card>
        </React.Fragment>
    );
}
